<template>
<div class="chapter">
<div class="inner_page">
<p class="image-h"><a id="page_8"><img alt="image" src="html/images/f0008-01.jpg"/></a></p><a id="page_8">
<p class="h3" id="lev174">THE HUNTER.</p>
<p class="noindent">IS a happy combination of the Race Horse with others of superior strength, but inferior in swiftness; and may be considered as the most useful breed of Horses in Europe. Their spirit and activity in the field are well known, and can only be equalled by the perseverance with which they endure the much more severe labour of posting on the road, which is now carried on by this active and hardy race, with a celerity unknown at any former period.</p>
<p class="indent">Geldings of this kind are sent over to the continent in great numbers: their superior worth is universally acknowledged abroad; and they are sold at very high prices, to foreigners of the first distinction.</p>
<p class="indent">The mixture of this with others of inferior rank, forms an endless variety, the different gradations becoming too minute to be discriminated.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226044859_11_ch3.vue?38fbb72c